/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/colonization_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 7.5a4.505 4.505 0 00-4.5 4.5c0 2.311 1.756 4.197 4 4.449V26h1v-9.551c2.244-.252 4-2.139 4-4.449 0-2.481-2.02-4.5-4.5-4.5zm0 8c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>'
  }
})
